export default __webpack_public_path__ + "static/media/B0003.3d98fee9.png";